<template>
    <div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">Box Type</label>
                      <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterBoxType">
                        <option value="GREY">GREY</option>
                        <option value="BLACK">BLACK</option>                  
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">Status</label>
                      <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterStatus">
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="DELETED">DELETED</option>                  
                        <option value="INACTIVE">INACTIVE</option>                  
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <!-- <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button> -->
                    <button @click="search()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="abs-btn-grp">
            <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
              <i @click="search()"  class="fas fa-search active cursor-pointer mt-0" aria-hidden="true"></i>
              <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
              <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer mt-0"></i>
            </form>
              <button @click="addFilter()" type="button" class="btn btn-success rounded "><i class="fas fa-plus"></i> Add </button>

           
          </div>
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                              <th
                                scope="col" 
                                class="sort text-left"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'name'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'name'  ? 'sort-desc' : '']"  
                                @click="sort('name')">Name</th>
                              
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'matchedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'matchedCount'  ? 'sort-desc' : '']"  
                                @click="sort('matchedCount')">Bid wanted Hit count 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number Bid wanteds hitting the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'suggestedPriceCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'suggestedPriceCount'  ? 'sort-desc' : '']"  
                                @click="sort('suggestedPriceCount')">Suggested
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of Bids suggested with the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'failedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'failedCount'  ? 'sort-desc' : '']"  
                                @click="sort('failedCount')">Failed
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of Bid wanteds for which price suggestion failed after hitting the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidCount'  ? 'sort-desc' : '']"  
                                @click="sort('bidCount')">Bid Count
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of bids sent with the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                              <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'newCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'newCount'  ? 'sort-desc' : '']"  
                                @click="sort('newCount')">REJECTED 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of suggested bids that have not yet been sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedCount'  ? 'sort-desc' : '']"  
                                @click="sort('executedCount')">Executed Count
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids executed among those hit this strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>  
                              <!-- <th
                                scope="col" 
                                class="sort text-center"
          
                                >box type</th> -->
                              <th
                                scope="col" 
                                class="sort text-center"
          
                                >status</th>
                              <th
                                scope="col" 
                                class="sort text-center"
                                >Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="savedFilters.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in savedFilters" :key="data.id">
                              <td class="text-left">{{data.name}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.matchedCount : ""}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.suggestedPriceCount  : ""}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.failedCount  : ""}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.bidCount  : ""}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.newCount  : ""}}</td>
                              <td class="text-right">{{data.bidCountLogByStrategy ? data.bidCountLogByStrategy.executedCount  : ""}}</td>
                              <!-- <td class="text-center">{{data.boxType}}</td> -->
                              <td class="text-center">
                                <toggle-button :sync="true" v-model="data.enable" @change="onChangeEventHandler(data)"/>
                               </td>
                               <td class="text-center">
                                <button @click="editFilter(data)" class="btn btn-primary" type="button">
                                    <i class="fas fa-pen"></i>
                                  </button>
                                  <button @click="deleteFilter(data)" class="btn btn-danger" type="button">
                                    <i class="fas fa-trash"></i>
                                  </button>
                                  <button @click="duplicateFilter(data)" class="btn btn-info" type="button">
                                    <i class="fas fa-clone"></i>
                                  </button>
                               </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getSavedFilters(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <AddCalculationFilter 
          v-if="showAddFilterModal"
          v-bind:selectedfilter="selectedFilter"
          @close="toggleAddFilterDataModal()"
        />  
    </div>    
    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
// import Datepicker from 'vuejs-datepicker';
import AddCalculationFilter from "./AddCalculationFIlter"
export default {
  name: "imsCusipComponent",
  components : {
    AddCalculationFilter
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        savedFilters : [],
        showAddFilterModal : false,
        selectedFilter : null,
        isSearchOnly : false,
        showFilters : false,
        filterBoxType : "GREY",
        filterStatus : "ACTIVE"
    };
  },
  methods: {
    onChangeEventHandler(filter){
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let addData = {
            "filterId":filter.id,
            "status": filter.enable ? "ACTIVE" : "INACTIVE"
          }
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/calcfilter-update-status?cognitoSub="+authService.getUser().cognitoSub,addData,auth)
          .then(() => {
            this.loading = false; 
            this.getSavedFilters();
           
          })
          .catch(() => {
              this.loading = false;              
          });

    },
    editFilter(filter){
      this.selectedFilter = filter;
      this.showAddFilterModal = !this.showAddFilterModal;
    },
    addFilter(){
      this.selectedFilter = null;
      this.showAddFilterModal = !this.showAddFilterModal;
    },
    duplicateFilter(filter){
      // Create a copy of the filter object without the 'id' field
      const filterCopy = { ...filter };
      delete filterCopy.id;
      filterCopy.name = filter.name+" duplicate"
      // Assign the modified copy to the selectedFilter
      this.selectedFilter = filterCopy;

      // Toggle the modal
      this.showAddFilterModal = !this.showAddFilterModal;
    },

    deleteFilter(filter){
      var message = "Are you sure you want to delete?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
       
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/calcfilter/calcfilter-delete?filterId="+filter.id+"&cognitoSub="+authService.getUser().cognitoSub,"",auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Deleted successfully","","success");            
            this.getSavedFilters();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    toggleAddFilterDataModal(){
      this.showAddFilterModal = !this.showAddFilterModal;
      this.getSavedFilters();
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getSavedFilters();
    },
    search(){
        this.currentPage = 1;
        this.getSavedFilters();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getSavedFilters();  
    },
    getUserSetting(){
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlBidSide +
              "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
              result.data.forEach(element => {
                if(element.setting == "AUTOBIDDER_BOX_TYPE"){
                  this.filterBoxType = element.value ? element.value : 'GREY';
                }
              });

              this.getSavedFilters();
        
          })
          .catch(e => {
              console.log(e);
          });
    },
    getSavedFilters(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/calcfilter/calcfilter-listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&traderId="+
            authService.getUser().id+
            "&startOfDay="+
            this.moment(this.moment().format("MM-DD-YYYY")).utc().format("YYYY-MM-DD HH:mm:ss")+
            "&boxType="+
            this.filterBoxType+
            "&status="+
            this.filterStatus,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.status == "ACTIVE"){
              element.enable = true
            }else{
              element.enable = false

            }
          });
          this.savedFilters = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
  },
  mounted() {
    this.getUserSetting();
  }
};
</script>

<style scoped>
button.btn-danger{
  min-width: 0;
}
</style>